var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { MediaSummary } from '../../commons/medias/media';
/**
 * Affected endpoints
 * GET /manfredite/projects
 * POST /manfredite/projects/<id>
 * PUT /manfredite/projects/<id>
 */
export class ProjectResponse {
    static _OPENAPI_METADATA_FACTORY() {
        return { id: { required: true, type: () => Number }, type: { required: true, type: () => Object }, title: { required: true, type: () => String }, description: { required: false, type: () => String }, dateFrom: { required: true, type: () => Date }, dateTo: { required: false, type: () => Date }, technologies: { required: true, type: () => [require("../techs/tech-summary").TechSummary] }, logo: { required: false, type: () => require("../../commons/medias/media").MediaSummary }, url: { required: false, type: () => String } };
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ProjectResponse.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ProjectResponse.prototype, "type", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ProjectResponse.prototype, "title", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ProjectResponse.prototype, "description", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], ProjectResponse.prototype, "dateFrom", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], ProjectResponse.prototype, "dateTo", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], ProjectResponse.prototype, "technologies", void 0);
__decorate([
    Expose(),
    __metadata("design:type", MediaSummary)
], ProjectResponse.prototype, "logo", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ProjectResponse.prototype, "url", void 0);
//# sourceMappingURL=project.response.js.map